export const SLOT_REGEX = /\[\[([^\]]+)\]\]/g;

export function parseSlots(body) {
  const parts = [];
  if (!body) return parts;
  const re = /\[\[([^\]]+)\]\]/g;
  let lastIdx = 0;
  let m;
  let i = 0;
  while ((m = re.exec(body)) !== null) {
    if (m.index > lastIdx) {
      parts.push({ type: "text", value: body.slice(lastIdx, m.index) });
    }
    parts.push({ type: "input", label: m[1].trim(), index: i++ });
    lastIdx = re.lastIndex;
  }
  if (lastIdx < body.length) {
    parts.push({ type: "text", value: body.slice(lastIdx) });
  }
  return parts;
}

export function hasSlots(body) {
  if (!body) return false;
  return /\[\[[^\]]+\]\]/.test(body);
}

export function fillSlots(body, values) {
  if (!body) return "";
  return body.replace(/\[\[([^\]]+)\]\]/g, (_, label) => {
    const key = label.trim();
    const v = values?.[key];
    return v && String(v).trim() ? String(v) : `[[${key}]]`;
  });
}
